<template>
  <div class="side-nav-item">
    <div
      v-if="selected"
      :style="
        'position: absolute; left: 0px; height: 48px; width: 6px; background-color: ' +
        $colors.penChecksTeal
      "
    ></div>

    <v-tooltip right :disabled="noTooltips">
      <template v-slot:activator="{ on }">
        <v-list-item :to="to" v-on="on" :data-id="dataId">
          <v-list-item-icon>
            <pc-icon
              v-if="icon"
              :size="iconSize"
              class="side-nav-item-content"
              :class="{ selected: selected }"
              :name="icon"
              width="20"
            ></pc-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              class="side-nav-item-content"
              :class="{ selected: selected }"
              >{{ title }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </template>

      <span>{{ title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: 16,
    },
    noTooltips: {
      type: Boolean,
      default: false,
    },    
    dataId: {
      type: String,
      required: false,
      validator(value) {
        return value.length == 32;
      },
    },
  },

  data: () => ({}),

  methods: {},
};
</script>

<style lang="scss">
.side-nav-item {
  .v-list-item,
  .v-list-item--active,
  .v-list-item__icon,
  .v-icon,
  .side-nav-item-content {
    color: $penChecksDarkGray !important;

    &.selected {
      color: $penChecksTeal !important;
    }
  }

  .side-nav-item-content.selected {
    font-weight: bold;
  }

  .v-list-item__icon {
    margin-right: 14px !important;
  }

  .v-list-item__title {
    font-size: 14px;
  }
}
</style>
